module.exports = __webpack_public_path__ + "img/word.394e57e6.png";